import React, { useCallback, useEffect, useState } from 'react'
import { toast } from 'react-toastify'
import { Col, Form, OverlayTrigger, Modal, Row, Badge, Tooltip, Placeholder } from 'react-bootstrap'
import { cookiesKeyNames } from '@revbox/common-fe'
import { getPubAbbr, formatThousand } from '@revbox/helpers-fe'
import {
    render_status_labels,
    ppc_modal_tooltips,
    ppc_modal_labels,
    ppc_modal_alert_messages,
    ppcManagmentModalToasts,
    loadingMessages
} from '@revbox/localization'

import { mixpanelInstance } from '@mixpanel/instance'
import { placeholderLogoModule } from '@modules/placeholderLogo'
import { editInventoryCampaign, getInventoryCampaignByInventoryAndCampaign } from '@services/micro'
import getMinCpc from '@services/micro/get_min_cpc'
import { getCampaign, getEstimatedPosition } from '@services/adv'
import { getPublisher } from '@services/pub'
import { useCookiesContext } from '@contexts/CookiesContext'
import { TaxonomyModule } from '@modules/taxonomy'
import { Loader } from 'rsuite'
import darkLoader from '@assets/gifs/netnetiX_black.gif'
import lightLoader from '@assets/gifs/netnetiX_white.gif'

import { OverlayContainer } from '@services/currency/RenderTooltip'
import { useEurUsdRate } from '@hooks/useEurUsdRate'
import { useJoyride } from '@contexts/JoyrideContext'
import IntervalAuctionPreview from '../components/IntervalAuctionPreview'
import PreviewLoader from '../components/PreviewLoader'
import useTourOnBidModal from '@hooks/useTourOnBidModal'
import BidStatusTooltip from './BidStatusTooltip'
import PPCAlerts from './PPCAlerts'
import BidModalButtons from './BidModalButtons'
import BidModalAmount from './BidModalAmount'
import BidStatusLabel from './BidStatusLabel'
import { CustomizeAdTab } from './BidModalTabs/CustomizeAdTab'
import ContentAuctionTabs from './BidModalTabs/ContentAuctionTabs'

import { PPCManagmentModalConfig } from './config'
import PPCModalPlacements from '../components/PPCModalPlacements'

const { REVIEW_STATUS, DRAFT_STATUS, LIVE_STATUS, REJECTED_STATUS, HTR_STAGE_PUBLISHER_ID, HTR_PUBLISHER_ID, DEFAULT_ID } = PPCManagmentModalConfig

function returnMessage(
    clicks,
    missed_clicks,
    click_opportunity,
    top_bid,
    cpc,
    active,
    bid_amount,
    min_bid,
    min_increment,
    status,
    current_position,
    estimated_position,
    inventory_type,
    is_campaign_active,
    is_ppc_bid_active
) {
    if (clicks === undefined && missed_clicks === undefined && click_opportunity === undefined) {
        return ''
    }

    if (isNaN(click_opportunity) && isNaN(clicks) && isNaN(missed_clicks)) {
        return ''
    }

    const publisherIdByAbbr = getPubAbbr()
    const taxonomy = TaxonomyModule(publisherIdByAbbr)

    if (status === REVIEW_STATUS) {
        return taxonomy.tooltips.ppc_managment_modal.main_lower_tooltip.pending
    }

    let increment = 0

    // estimated_position = 3, current_position = 1

    if (is_campaign_active && is_ppc_bid_active) {
        // IF CURRENT POSITION IS 1 & ESTIMATED POSITION IS 1, THEN THE BID IS OPTIMIZED
        if (estimated_position === 1 && current_position === 1) {
            if (clicks === 0) {
                return ''
            }

            return taxonomy.tooltips.ppc_managment_modal.main_lower_tooltip.optimized.replace('{clicks}', clicks)
        }

        // IF CURRENT POSITION IS NOT 1 & ESTIMATED POSITION IS 1, THEN THE BID IS OPTIMIZED
        if (estimated_position === 1 && current_position !== 1) {
            if (missed_clicks === 0) {
                return ''
            }

            return taxonomy.tooltips.ppc_managment_modal.main_lower_tooltip.optimized.replace('{clicks}', missed_clicks)
        }
    }

    // IF INVENTORY TYPE IS NOT CLUSTER AND NOT ACTIVE, THEN THE BID IS NO BID
    if (inventory_type !== 5 && !active) {
        if (top_bid > 0) {
            increment = top_bid + min_increment
        } else {
            increment = min_bid + min_increment
        }

        if (missed_clicks === 0) {
            console.log('Missed clicks is 0, if (inventory_type !== 5 && !active)')
            return ''
        }

        return taxonomy.tooltips.ppc_managment_modal.main_lower_tooltip.no_bid
            .replace('{missed_clicks}', missed_clicks)
            .replace('{top_bid_plus_one}', increment)
    }

    // IF BID AMOUNT IS GREATER THAN CURRENT POSITION AND CURRENT POSITION IS LESS THAN 1, THEN THE BID IS ACTIVE BUT NOT OPTIMIZED
    if (bid_amount >= current_position && estimated_position > 1) {
        if (top_bid > 0) {
            increment = top_bid - cpc + min_increment
        } else {
            increment = min_bid - cpc + min_increment
        }

        if (missed_clicks === 0) {
            console.log('Missed clicks is 0, if (bid_amount >= current_position && estimated_position > 1)')
            return ''
        }

        return taxonomy.tooltips.ppc_managment_modal.main_lower_tooltip.active_bid_but_not_optimized
            .replace('{clicks}', missed_clicks)
            .replace('{increase_by}', increment)
            .replace('{relative_opportunity}', click_opportunity === 0 ? '0.1' : click_opportunity)
    }

    // IF BID AMOUNT IS LESS THAN CURRENT POSITION, THEN THE BID IS OUTBID
    if (bid_amount < current_position && estimated_position > 1) {
        if (missed_clicks === 0) {
            console.log('Missed clicks is 0, if (bid_amount < current_position && estimated_position > 1)')
            return ''
        }

        if (top_bid > 0) {
            increment = top_bid + min_increment
        } else {
            increment = min_bid + min_increment
        }

        return taxonomy.tooltips.ppc_managment_modal.main_lower_tooltip.no_bid
            .replace('{missed_clicks}', missed_clicks)
            .replace('{top_bid_plus_one}', increment)
    }

    return ''

    // // NO ACTIVE BID
    // if (!active) {
    //     console.log('case 2');

    //     if (missed_clicks === 0) {
    //         return ''
    //     }

    //     if (increment === 0) {
    //         return ''
    //     }

    //     console.log('case 2.1');
    //     return taxonomy.tooltips.ppc_managment_modal.main_lower_tooltip.no_bid
    //         .replace('{missed_clicks}', missed_clicks)
    //         .replace('{top_bid_plus_one}', increment)
    // }

    // // ACTIVE BID
    // if (position <= bid_amount || current_position <= bid_amount) {
    //     console.log('case 3');

    //     if (top_bid > 0) {
    //         increment = top_bid - cpc + min_increment
    //     } else {
    //         increment = min_bid + min_increment
    //     }

    //     if (position !== 1) {
    //         if (missed_clicks > 0) {
    //             console.log('case 4.1');
    //             return taxonomy.tooltips.ppc_managment_modal.main_lower_tooltip.no_bid.replace('{missed_clicks}', missed_clicks)
    //                 .replace('{top_bid_plus_one}', increment)
    //         } else {
    //             return ''
    //         }
    //     }

    //     if (increment > 0 && click_opportunity > 0) {
    //         console.log('case 4');
    //         if (click_opportunity === 0) {
    //             return ''
    //         }

    //         if (clicks === 0) {
    //             return ''
    //         }

    //         if (increment === 0) {
    //             return ''
    //         }
    //         console.log('case 5.1');
    //         return taxonomy.tooltips.ppc_managment_modal.main_lower_tooltip.active_bid_but_not_optimized
    //             .replace('{clicks}', clicks)
    //             .replace('{increase_by}', increment)
    //             .replace('{relative_opportunity}', click_opportunity)
    //     } else {
    //         console.log('case 5');
    //         if (clicks > 0) {
    //             return taxonomy.tooltips.ppc_managment_modal.main_lower_tooltip.optimized.replace('{clicks}', clicks)
    //         } else {
    //             return ''
    //         }
    //     }
    // }

    // console.log('case 6');
    // if (clicks > 0) {
    //     console.log('case 7');
    //     return taxonomy.tooltips.ppc_managment_modal.main_lower_tooltip.optimized.replace('{clicks}', clicks)
    // } else {
    //     console.log('case 8');
    //     return ''
    // }
}

function renderStatus(
    campaign_active,
    status,
    ppc_bid_active,
    ppc_paused,
    inherited_cpc,
    inherited_bid_mode,
    clusterLevel,
    cluster_status,
    language
) {
    const statusLabels = render_status_labels[language]

    if (cluster_status) {
        if (cluster_status === 'Inactive') {
            return (
                <div className="badge bg-danger">
                    <span>{statusLabels.Inactive}</span>
                </div>
            )
        }

        if (cluster_status === 'Paused') {
            return (
                <div className="badge bg-warning">
                    <span>{statusLabels.Paused}</span>
                </div>
            )
        }

        if (cluster_status === 'Pending') {
            return (
                <div className="badge bg-secondary">
                    <span>{statusLabels.Pending}</span>
                </div>
            )
        }

        if (cluster_status === 'Bid Active') {
            return (
                <div className="badge bg-success">
                    <span>{statusLabels['Bid Active']}</span>
                </div>
            )
        }
    }

    if (inherited_bid_mode) {
        if (status === REVIEW_STATUS || status === 'REVIEW') {
            return (
                <div className="badge bg-secondary">
                    <span>{statusLabels.Pending}</span>
                </div>
            )
        } else if (status === 'REJECTED' || status === REJECTED_STATUS) {
            return (
                <div className="badge bg-danger">
                    <span>{statusLabels.Inactive}</span>
                </div>
            )
        } else {
            if (!ppc_bid_active && clusterLevel != 1 && inherited_cpc !== null) {
                return (
                    <div className="badge bg-warning">
                        <span>{statusLabels.Inherited}</span>
                    </div>
                )
            } else if (!ppc_bid_active && clusterLevel == 1) {
                return (
                    <div className="badge bg-danger">
                        <span>{statusLabels.Inactive}</span>
                    </div>
                )
            } else if (!ppc_bid_active && inherited_cpc === null && clusterLevel === 0) {
                return (
                    <div className="badge bg-danger">
                        <span>{statusLabels.Inactive}</span>
                    </div>
                )
            } else {
                return (
                    <div className="badge bg-success">
                        <span>{statusLabels['Bid Active']}</span>
                    </div>
                )
            }
            // if (inherited_cpc === null) {
            //     return (
            //         <div className="badge bg-success">
            //             <span>Bid Active</span>
            //         </div>
            //     );
            // } else {
            //     return (
            //         <div className="badge bg-warning">
            //             <span>Inherited</span>
            //         </div>
            //     );
            // }
        }
    }

    if (campaign_active && ppc_bid_active && !ppc_paused) {
        // todo: move it back for HTR prod
        // if (estimatedPosition?.current_position > estimatedPosition?.bid_amount && isHTR) {
        //   return (
        //     <div className="badge bg-warning">
        //       <span>Outbid</span>
        //     </div>
        //   );
        // }

        return (
            <div className="badge bg-success">
                <span>{statusLabels.Live}</span>
            </div>
        )
    }

    if (campaign_active && !ppc_bid_active) {
        return (
            <div className="badge bg-danger">
                <span>{statusLabels.Inactive}</span>
            </div>
        )
    }

    if (campaign_active && ppc_paused) {
        return (
            <div className="badge bg-warning">
                <span>{statusLabels.Paused}</span>
            </div>
        )
    }

    if (campaign_active && !ppc_paused && (status === 'DRAFT' || status === DRAFT_STATUS || status === REVIEW_STATUS || status === 'REVIEW')) {
        return (
            <div className="badge bg-secondary">
                <span>{statusLabels.Pending}</span>
            </div>
        )
    }

    return (
        <div className="badge bg-danger">
            <span>{statusLabels.Inactive}</span>
        </div>
    )
}

function renderStatusStr(
    campaign_active,
    status,
    ppc_bid_active,
    ppc_paused,
    inherited_cpc,
    inherited_bid_mode,
    clusterLevel,
    cluster_status,
    language
) {
    const statusLabels = render_status_labels[language]

    if (cluster_status) {
        if (cluster_status === 'Inactive') {
            return statusLabels.Inactive
        }

        if (cluster_status === 'Paused') {
            return statusLabels.Paused
        }

        if (cluster_status === 'Pending') {
            return statusLabels.Pending
        }

        if (cluster_status === 'Bid Active') {
            return statusLabels.Live
        }
    }

    if (inherited_bid_mode) {
        if (status === REVIEW_STATUS || status === 'REVIEW') {
            return statusLabels.Pending
        } else if (status === 'REJECTED' || status === REJECTED_STATUS) {
            return statusLabels.Inactive
        } else {
            if (!ppc_bid_active && clusterLevel != 1 && inherited_cpc !== null) {
                return statusLabels.Inherited
            } else if (!ppc_bid_active && clusterLevel == 1) {
                return statusLabels.Inactive
            } else if (!ppc_bid_active && inherited_cpc === null && clusterLevel === 0) {
                return statusLabels.Inactive
            } else {
                return statusLabels.Live
            }
        }
    }

    if (campaign_active && ppc_bid_active && !ppc_paused) {
        // todo: move it back for HTR prod
        // if (estimatedPosition?.current_position > estimatedPosition?.bid_amount && isHTR) {
        //   return 'Outbid'
        // }

        return statusLabels.Live
    }

    if (campaign_active && !ppc_bid_active) {
        return statusLabels.Inactive
    }

    if (campaign_active && ppc_paused) {
        return statusLabels.Paused
    }

    if (campaign_active && !ppc_paused && (status === 'DRAFT' || status === DRAFT_STATUS || status === REVIEW_STATUS || status === 'REVIEW')) {
        return statusLabels.Pending
    }

    return statusLabels.Inactive
}

// TODO: should add a logic for Content Auctions button save (checkers of all "custom ad" fields)

export default function PPCManagmentModal({
    show,
    handleClose,
    campaignId,
    inventoryId,
    updatePage,
    token,
    setUpdatePage,
    isClusterInventoryCampaign,
    clusterLevel,
    allChildrenCount,
    anyActiveChild,
    anyInactiveParent,
    views,
    allowed,
    auctionType,
    isContentAd,
    setBudgetLoading
}) {
    const publisherIdByAbbr = getPubAbbr()
    const taxonomy = TaxonomyModule(publisherIdByAbbr)

    const { cookiesData, getPathKey, getSkinMode, getLanguageAbbr, getIsTourCompleted } =
        useCookiesContext()
    const currentSkin = getSkinMode()
    const { rate } = useEurUsdRate()
    const [cpcInputValue, setCpcInputValue] = useState(null)
    const [campaign, setCampaign] = useState()
    const [innitialInventoryCampaign, setInnitialInventroyCampaign] = useState()
    const [inventoryCampaign, setInventoryCampaign] = useState()
    const [estimatedPosition, setEstimatedPosition] = useState()
    const [canPositionBeEstimated, setCanPositionBeEstimated] = useState(false)
    const [publisher, setPublisher] = useState()
    const [loading, setLoading] = useState(false)
    const [estimateIsLoading, setEstimateIsLoading] = useState(false)
    const language = getLanguageAbbr()
    const toastMessages = ppcManagmentModalToasts[language]
    const { startTour, isTourTriggered } = useJoyride()
    const [defaultValue, setDefaultValue] = useState()
    const [currentTab, setCurrentTab] = useState('manage_bid')
    const handleSwitchTab = useCallback((tab) => () => {
        setCurrentTab(tab)
      }, [setCurrentTab])
  
    // Function to generate consistent but seemingly random widths for each index
    const getConsistentWidth = index => {
        // Simple xorshift hash for small integer index
        let x = index + 12345
        x ^= x << 13
        x ^= x >> 17
        x ^= x << 5
        // Normalize to [0, 1]
        const rand = Math.abs(x % 10000) / 10000
        // Width between 80px and 120px
        return `${Math.floor(80 + rand * 40)}px`
    }

    useEffect(() => {
        if (inventoryId && campaignId) {
            setEstimateIsLoading(true)
            getInventoryCampaignByInventoryAndCampaign(inventoryId, campaignId)
                .then(response => {
                    if (response && response.data) {
                        console.log('response.data', response.data)
                        setInnitialInventroyCampaign(response.data)
                        // add a checker if min_bid is greater than cpc, then set cpc to min_bid
                        const inventoryCampaign = {
                            ...response.data,
                            cpc: response.data?.min_bid >= response.data?.cpc ? response.data?.min_bid : response.data?.cpc
                        }

                        setInventoryCampaign(inventoryCampaign)

                        let cpc = response.data?.cpc

                        if (response.data?.inherited_cpc && response.data?.ppc_bid_active === false) {
                            cpc = response.data?.inherited_cpc
                        }

                        if (!cpc || cpc < response.data?.min_bid) {
                            cpc = response.data?.min_bid
                        }

                        let inv_cam_default_value = response.data?.cpc
                        // console.log('inv_cam_default_value 1:', inv_cam_default_value)
                        if (!inv_cam_default_value || inv_cam_default_value < response.data?.min_bid) {
                            inv_cam_default_value = response.data?.min_bid
                        }

                        setDefaultValue(inv_cam_default_value)

                        getEstimatedPosition(response.data?.id, cpc, response.data?.ppc_bid_active)
                            .then(res => {
                                setEstimatedPosition(res.data)
                                
                                // Use min_bid from API (already calculated by Backend)
                                const minRequiredBid = response.data?.min_bid || 0;
                                
                                // If user's current CPC is below minimum required, set to minimum required
                                let finalCpc = cpc;
                                if (cpc < minRequiredBid) {
                                    finalCpc = minRequiredBid;
                                }
                                
                                setDefaultValue(finalCpc);
                                setInventoryCampaign({ ...inventoryCampaign, cpc: finalCpc });
                                setCanPositionBeEstimated(true);
                            })
                            .catch(err => {
                                console.log('Error fetching estimated position', err)
                            })
                            .finally(() => {
                                setEstimateIsLoading(false)
                            })
                    }
                })
                .finally(() => {
                    setEstimateIsLoading(false)
                })

            getCampaign(campaignId, token).then(response => {
                if (response) {
                    setCampaign(response.data)
                }
            })
        }

        if (publisherIdByAbbr && publisherIdByAbbr !== 'undefined' && publisherIdByAbbr !== 'null') {
            getPublisher(publisherIdByAbbr).then(response => {
                if (response) {
                    setPublisher(response.data)
                }
            })
        } else {
            const publisherId = cookiesData[getPathKey()]?.[cookiesKeyNames.publisherId]

            getPublisher(publisherId).then(response => {
                if (response) {
                    setPublisher(response.data)
                }
            })
        }
    }, [inventoryId, campaignId, token])

    const isHTR = publisherIdByAbbr === HTR_PUBLISHER_ID || publisherIdByAbbr === HTR_STAGE_PUBLISHER_ID
    // const isDefault = publisherIdByAbbr === DEFAULT_ID
    // const estimatePosition = canPositionBeEstimated || (campaign?.ppc_active && !campaign?.ppc_paused)

    const isContentAdMissingData =
            !inventoryCampaign?.content_type ||
            !inventoryCampaign?.tagline ||
            !inventoryCampaign?.custom_description ||
            !inventoryCampaign?.img_lg

    const handleSave = () => {
        setLoading(true)

        if (isContentAd) {
            if (isContentAdMissingData) {
                toast.warn(toastMessages.finish_customizing_ad)
                return false
            }
        }

        if (inventoryCampaign?.custom_url?.length > 0) {
            if (inventoryCampaign?.custom_url?.length > 255) {
                toast.warn(toastMessages.long_custom_url)
                return false
            }

            if (inventoryCampaign?.custom_url?.includes(' ')) {
                toast.warn(toastMessages.spaces_in_custom_url)
                return false
            }

            if (!inventoryCampaign?.custom_url?.includes('http')) {
                toast.warn(toastMessages.any_protocol_in_custom_url)
                return false
            }

            if (inventoryCampaign?.custom_url?.includes('http://')) {
                toast.warn(toastMessages.https_in_custom_url)
                return false
            }

            if (!inventoryCampaign?.custom_url?.includes('.')) {
                toast.warn(toastMessages.domain_in_custom_url)
                return false
            }
        }

        const trackInventoryCampaignChanging = message => {
            mixpanelInstance.track(message, {
                campaignId,
                inventoryCampaignId: inventoryCampaign.id,
                cpc: Number(inventoryCampaign.cpc),
                custom_url: inventoryCampaign.custom_url,
                ppc_bid_active: inventoryCampaign.ppc_bid_active
            })
        }

        editInventoryCampaign(inventoryCampaign.id, {
            ...inventoryCampaign,
            cpc: Number(inventoryCampaign.cpc),
            custom_url: inventoryCampaign.custom_url,
            position:
                inventoryCampaign.cpc !== innitialInventoryCampaign.cpc ? estimatedPosition?.estimated_position : innitialInventoryCampaign.position,
            ppc_bid_active: inventoryCampaign.ppc_bid_active
        })
            .then(res => {
                handleClose()
                !!setBudgetLoading && setBudgetLoading(true)

                toast.success(toastMessages.queue_item_saved)

                trackInventoryCampaignChanging(`inventoryCampaign ${inventoryCampaign.id} saved successfully`)

                setUpdatePage(updatePage + 1)
            })
            .catch(err => {
                toast.error(toastMessages.error_saving_queue_item)

                trackInventoryCampaignChanging(`Error saving inventoryCampaign ${inventoryCampaign.id}`)
            })
            .finally(() => {
                setLoading(false)
                !!setBudgetLoading && setBudgetLoading(false)
            })
    }

    const updateCPC = useCallback((sign, min_bid) => {
        let increment = Number(publisher?.min_increment)
        if ([6,8,9].includes(inventoryCampaign?.inventory?.inventory_type)) {
            increment = 20
        }
        const change = sign === 'plus' ? increment : -increment

        let cpc = inventoryCampaign?.cpc

        if (!cpc || cpc < inventoryCampaign?.min_bid) {
            cpc = inventoryCampaign?.min_bid
        }

        let newCpc = Number((cpc + change).toFixed(1))

        if (sign === 'minus' && cpc <= min_bid) {
            toast.warn(toastMessages.cpc_cant_be_lower_than_min_cpc)
            newCpc = min_bid
        }

        if (sign === 'plus' && cpc < min_bid) {
            toast.warn(toastMessages.cpc_cant_be_lower_than_min_cpc)
            newCpc = min_bid
        }

        if (inventoryCampaign.inherited_cpc) {
            setInventoryCampaign({ ...inventoryCampaign, inherited_cpc: newCpc, cpc: newCpc })
        } else {
            setInventoryCampaign({ ...inventoryCampaign, cpc: newCpc })
        }

        setCpcInputValue(newCpc)

        mixpanelInstance.track(`Change cpc for ${campaign?.name} in bid management popup`, {
            campaignId,
            sign,
            newCpc
        })
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [inventoryCampaign, campaign, toastMessages])

    const handleSubmitBid = () => {
        setLoading(true)

        if (isContentAd && isContentAdMissingData) {
            toast.warn(toastMessages.finish_customizing_ad)
            return false
        }

        let submit_data = {
            ...inventoryCampaign,
            cpc: Number(inventoryCampaign?.cpc),
            ppc_bid_active: inventoryCampaign?.ppc_bid_active,
            custom_url: inventoryCampaign?.custom_url
        }

        if (inventoryCampaign?.inventory_campaign_status !== 1) {
            submit_data = {
                ...submit_data,
                inventory_campaign_status: REVIEW_STATUS
            }
        }

        editInventoryCampaign(inventoryCampaign.id, submit_data)
            .then(res => {
                handleClose()
                !!setBudgetLoading && setBudgetLoading(true)

                toast.success(toastMessages.bid_submitted_successfully)

                setUpdatePage(updatePage + 1)
            })
            .catch(err => {
                toast.error(toastMessages.error_submitting_bid)
            })
            .finally(() => {
                setLoading(false)
                !!setBudgetLoading && setBudgetLoading(false)
            })
    }

    const handleWithdrawBid = () => {
        setLoading(true)

        if (isContentAd && isContentAdMissingData) {
            toast.warn(toastMessages.finish_customizing_ad)
            return false
        }

        editInventoryCampaign(inventoryCampaign.id, {
            ...inventoryCampaign,
            inventory_campaign_status: DRAFT_STATUS
        })
            .then(res => {
                handleClose()
                !!setBudgetLoading && setBudgetLoading(true)
                toast.success(toastMessages.bid_withdrawn_successfully)

                setUpdatePage(updatePage + 1)
            })
            .catch(err => {
                toast.error(toastMessages.error_withdrawing_bid)
            })
            .finally(() => {
                setLoading(false)
                !!setBudgetLoading && setBudgetLoading(false)
            })
    }

    // const trackBidChange = (message, inventoryCampaignId) => {
    //     mixpanelInstance.track(`${message} for inventory campaign ${inventoryCampaignId}`, {
    //         campaignId,
    //         inventoryCampaignId
    //     })
    // }

    // const handleDeactivateBid = id => {
    //     setLoading(true)

    //     const isClicked = cookiesData[getPathKey()]?.[cookiesKeyNames.clickedDeactivate]

    //     if (!isClicked) {
    //         updateCookiesProperty(cookiesKeyNames.clickedDeactivate, 'true')

    //         editInventoryCampaign(id, {
    //             ppc_bid_active: false
    //         })
    //             .then(res => {
    //                 !!setBudgetLoading && setBudgetLoading(true)
    //                 toast.success(toastMessages.bid_deactivated_successfully)
    //                 trackBidChange('Bid deactivated successfully', id)

    //                 setUpdatePage(updatePage + 1)
    //             })
    //             .catch(err => {
    //                 toast.error(toastMessages.error_deactivating_bid)
    //                 removeCookiesProperty('clickedDeactivate')
    //                 trackBidChange('Error deactivating bid', id)
    //             })
    //             .finally(() => {
    //                 setLoading(false)
    //                 !!setBudgetLoading && setBudgetLoading(false)
    //             })
    //     }
    // }

    const onChangeCpc = e => {
        setEstimateIsLoading(true)
        // setTimeout(() => {
        getMinCpc('inventory_campaigns', null, inventoryCampaign?.inventory_id, inventoryCampaign?.campaign_id, inventoryCampaign?.id)
            .then(res => {
                // Use min_bid from API (already calculated by Backend)
                const minRequiredBid = res.data || inventoryCampaign?.min_bid || 0;
                
                let updatedCpc = 0
                if (Number(e.target.value) < minRequiredBid || isNaN(e.target.value)) {
                    toast.warn(toastMessages.cpc_cant_be_lower_than_min_cpc)
                    setInventoryCampaign({ ...inventoryCampaign, cpc: minRequiredBid })
                    setCpcInputValue(minRequiredBid)
                    updatedCpc = minRequiredBid
                } else {
                    let newCpc = Number(e.target.value)
                    // check if publisher?.min_increment allows to set cpc
                    // for example if publisher?.min_increment is 0.5 and updatedCpc is 1.2, then we should set cpc to 1
                    // if publisher?.min_increment is 1 and updatedCpc is 1.2, then we should set cpc to 2
                    // if publisher?.min_increment is 0.5 and updatedCpc is 0.4, then we should set cpc to 0.5

                    if (newCpc % publisher?.min_increment !== 0) {
                        newCpc = Math.ceil(newCpc / publisher?.min_increment) * publisher?.min_increment
                    }

                    setInventoryCampaign({ ...inventoryCampaign, cpc: newCpc })
                    setCpcInputValue(newCpc)
                    updatedCpc = newCpc
                }
                getEstimatedPosition(inventoryCampaign.id, updatedCpc, inventoryCampaign.ppc_bid_active)
                    .then(res => {
                        setEstimatedPosition(res.data)
                        setCanPositionBeEstimated(true)
                    })
                    .catch(err => {
                        console.log('Error fetching estimated position')
                    })
                    .finally(() => {
                        setEstimateIsLoading(false)
                    })
            })
            .finally(() => {
                setEstimateIsLoading(false)
            })
        // }, 2000)
    }

    const disableCPC = inventoryCampaign => {
        // if (allowed) {
        //     if (
        //         publisher?.cluster_enforce_mode_enabled &&
        //         publisher?.cluster_inherited_bid_mode_enabled  &&
        //         anyInactiveParent
        //     ) {
        //         return true
        //     }
        // }

        return false
    }

    let currentCPC = inventoryCampaign?.cpc

    const onChangeCpcByButton = sign => {
        setEstimateIsLoading(true)
        setTimeout(() => {
            getMinCpc('inventory_campaigns', null, inventoryCampaign?.inventory_id, inventoryCampaign?.campaign_id, inventoryCampaign?.id)
                .then(res => {
                    // Use min_bid from API (already calculated by Backend)
                    const minRequiredBid = res.data || inventoryCampaign?.min_bid || 0;
                    
                    let cpc = inventoryCampaign?.cpc

                    if (!cpc || cpc < minRequiredBid) {
                        cpc = minRequiredBid
                    }

                    if (sign === 'minus' && cpc <= minRequiredBid) {
                        toast.warn(toastMessages.cpc_cant_be_lower_than_min_cpc)
                        setInventoryCampaign({ ...inventoryCampaign, cpc: minRequiredBid })
                        setCpcInputValue(minRequiredBid)
                        setEstimateIsLoading(false)
                        return
                    }

                    updateCPC(sign, minRequiredBid)

                    let diff = 0
                    let increment = Number(publisher?.min_increment)
                    if ([6,8,9].includes(inventoryCampaign?.inventory?.inventory_type)) {
                        increment = 20
                    }
                    if (sign === 'plus') {
                        diff = increment
                    } else {
                        diff = -increment
                    }

                    getEstimatedPosition(inventoryCampaign.id, Number((cpc + diff).toFixed(1)), inventoryCampaign.ppc_bid_active)
                        .then(res_pos => {
                            setEstimatedPosition(res_pos.data)
                            setCanPositionBeEstimated(true)
                            setEstimateIsLoading(false)
                        })
                        .catch(err => {
                            console.log('Error fetching estimated position')
                        })
                })
                .finally(() => {
                    setEstimateIsLoading(false)
                })
        }, 200)
    }

    const onChangePPCActive = e => {
        setEstimateIsLoading(true)

        mixpanelInstance.track(`Change ppc active toggle for ${campaign?.name} in bid management popup`, {
            campaignId,
            ppcActive: e.target.checked
        })

        if (publisher?.cluster_enforce_mode_enabled && publisher?.cluster_inherited_bid_mode_enabled && clusterLevel === 1) {
            if (!e.target.checked && allChildrenCount > 0 && anyActiveChild) {
                toast(toastMessages.deactivate_bid_warning)

                return
            }
        }

        if (publisher?.cluster_inherited_bid_mode_enabled && publisher?.cluster_enforce_mode_enabled && clusterLevel !== 1 && !!clusterLevel) {
            if ((!e.target.checked && allChildrenCount > 0 && anyActiveChild) || !allowed) {
                toast.warn(toastMessages.deactivate_bid_warning)

                return
            }
        }

        // if (publisher?.cluster_enforce_mode_enabled && publisher?.cluster_inherited_bid_mode_enabled && !!clusterLevel) {
        //     if (!e.target.checked && allChildrenCount > 0 && !anyActiveChild) {
        //         toast.warn(toastMessages.deactivate_bid_warning)

        //         return
        //     }
        // }

        if (!publisher?.cluster_enforce_mode_enabled && publisher?.cluster_inherited_bid_mode_enabled && !!clusterLevel) {
            if (!e.target.checked && allChildrenCount > 0 && !anyActiveChild) {
                toast.warn(toastMessages.deactivate_bid_parent_cluster_warning)
            }
        }

        setInventoryCampaign({
            ...inventoryCampaign,
            ppc_bid_active: e.target.checked
        })

        getEstimatedPosition(inventoryCampaign.id, Number(inventoryCampaign.cpc), e.target.checked)
            .then(res => {
                setEstimatedPosition(res.data)
                setCanPositionBeEstimated(true)
            })
            .catch(err => {
                console.log('Error fetching estimated position')
            })
            .finally(() => {
                setEstimateIsLoading(false)
            })
    }

    const onChangeCustomUrl = e => {
        setInventoryCampaign({
            ...inventoryCampaign,
            custom_url: e.target.value.trim()
        })
    }

    const tooltipContent = returnMessage(
        estimatedPosition?.est_clicks,
        estimatedPosition?.est_missed_clicks,
        estimatedPosition?.est_click_opportunity,
        estimatedPosition?.top_bid ? estimatedPosition?.top_bid : inventoryCampaign?.stat?.top_cpc_bid,
        inventoryCampaign?.cpc,
        inventoryCampaign?.ppc_bid_active,
        estimatedPosition?.bid_amount,
        inventoryCampaign?.min_bid,
        publisher?.min_increment,
        inventoryCampaign?.inventory_campaign_status,
        estimatedPosition?.current_position,
        estimatedPosition?.estimated_position,
        inventoryCampaign?.inventory?.inventory_type,
        campaign?.ppc_active,
        inventoryCampaign?.ppc_bid_active
    )

    const translatedPpcModalTooltips = ppc_modal_tooltips[language]

    const renderPosition = (estimatedPosition, inventoryCampaign) => {
        // 0. if estimated_position === current_position & current_position <= items_amount, then return current_position
        if (
            estimatedPosition?.estimated_position === estimatedPosition?.current_position &&
            estimatedPosition?.current_position <= estimatedPosition?.bid_amount
        ) {
            return '#' + estimatedPosition?.current_position
        }

        // 1. if estimated_position === current_position & current_position > items_amount, then return not_shown
        if (
            estimatedPosition?.estimated_position === estimatedPosition?.current_position &&
            estimatedPosition?.current_position > estimatedPosition?.bid_amount
        ) {
            return (
                <div className="d-flex align-items-center">
                    <div className="d-flex align-items-center">
                        <small>{translatedPpcModalTooltips.not_shown}</small>
                    </div>
                </div>
            )
        }

        // 2. if current_position > items_amount & estimated_position > items_amount, then return not_shown
        if (
            estimatedPosition?.current_position > estimatedPosition?.bid_amount &&
            estimatedPosition?.estimated_position > estimatedPosition?.bid_amount
        ) {
            return (
                <div className="d-flex align-items-center">
                    <div className="d-flex align-items-center">
                        <small>{translatedPpcModalTooltips.not_shown}</small>
                    </div>
                </div>
            )
        }

        // 3. if current_position > items_amount & estimated_position <= items_amount, then return not_shown => estimated_position
        if (
            estimatedPosition?.current_position > estimatedPosition?.bid_amount &&
            estimatedPosition?.estimated_position <= estimatedPosition?.bid_amount
        ) {
            return (
                <div className="d-flex align-items-center">
                    <div className="d-flex align-items-center">
                        <small style={{ marginRight: 5 }}>{translatedPpcModalTooltips.not_shown}</small>
                        <i className="ri-arrow-right-line" data-bs-toggle="tooltip" title="Estimated position"></i>
                        <span style={{ marginLeft: 5 }}>#{estimatedPosition?.estimated_position}</span>
                    </div>
                </div>
            )
        }

        // 4. if current_position < items_amount & estimated_position <= items_amount, then return current_position => estimated_position
        if (
            estimatedPosition?.current_position <= estimatedPosition?.bid_amount &&
            estimatedPosition?.estimated_position <= estimatedPosition?.bid_amount
        ) {
            return (
                <div className="d-flex align-items-center">
                    <div className="d-flex align-items-center">
                        <small style={{ marginRight: 5 }}>#{estimatedPosition?.current_position}</small>
                        <i className="ri-arrow-right-line" data-bs-toggle="tooltip" title="Estimated position"></i>
                        <span style={{ marginLeft: 5 }}>#{estimatedPosition?.estimated_position}</span>
                    </div>
                </div>
            )
        }

        // 5. if current_position <= items_amount & estimated_position > items_amount, then return current_position => not_shown
        if (
            estimatedPosition?.current_position <= estimatedPosition?.bid_amount &&
            estimatedPosition?.estimated_position > estimatedPosition?.bid_amount
        ) {
            return (
                <div className="d-flex align-items-center">
                    <div className="d-flex align-items-center">
                        <small style={{ marginRight: 5 }}>#{estimatedPosition?.current_position}</small>
                        <i className="ri-arrow-right-line" data-bs-toggle="tooltip" title="Estimated position"></i>
                        <span style={{ marginLeft: 5 }}>{translatedPpcModalTooltips.not_shown}</span>
                    </div>
                </div>
            )
        }
    }


    const hasInventoryUrl = inventoryCampaign?.inventory?.url && inventoryCampaign?.inventory?.url !== ''
    const hasDirectoryPlacement = !!inventoryCampaign?.inventory && !!inventoryCampaign?.directory_placement
    const hasMagazinePlacement = !!inventoryCampaign?.inventory && !!inventoryCampaign?.magazine_placement

    const hasAltVersions = Array.isArray(inventoryCampaign?.alt_versions) && inventoryCampaign.alt_versions.length > 0

    useTourOnBidModal({
        hasInventoryUrl,
        hasDirectoryPlacement,
        hasMagazinePlacement,
        hasAltVersions,
        isTourTriggered,
        startTour,
        getIsTourCompleted,
        publisher
    })
    const loading_message = loadingMessages[language]

    if (loading && isClusterInventoryCampaign) {
        return (
            <Modal show={show} size="lg" centered>
                <Modal.Header closeButton className="card-one pb-2">
                    <Modal.Title></Modal.Title>
                </Modal.Header>
                <Modal.Body className="card-one pt-0">
                    <Row>
                        <Col sm="12">
                            <div className="text-center mb-4">
                                <img src={currentSkin === 'dark' ? lightLoader : darkLoader} alt={loading_message} width="auto" height="150" />
                            </div>
                            <div className="text-center align-items-center justify-content-center">
                                <span className={`${currentSkin === 'dark' ? 'text-white' : 'text-dark'} fw-bold`}>
                                    <Loader className="me-2" />
                                    Updating your {inventoryCampaign?.inventory?.name} bid
                                </span>
                                <br />
                                <span className="text-secondary">Please wait a few seconds</span>
                            </div>
                            <div className="text-center mt-5 mb-2">
                                <div className="divider">
                                    <span className="text-priary fw-bold">QUICK TIP</span>
                                </div>
                                <div className="text-secondary text-italic p-3">
                                    {taxonomy.tooltips.ppc_managment_modal.cluster_tips[String(Math.floor(Math.random() * 10) + 1)]}
                                </div>
                            </div>
                        </Col>
                    </Row>
                </Modal.Body>
            </Modal>
        )
    }

    const isSubmitOnSaveButtonDisabled = ({ innitialInventoryCampaign, inventoryCampaign, campaign, estimateIsLoading }) => {
        if (estimateIsLoading) {
            return true
        }

        const cpc = inventoryCampaign?.cpc
        const minBid = innitialInventoryCampaign?.min_bid

        const nothingChanged =
            innitialInventoryCampaign?.cpc === inventoryCampaign?.cpc &&
            innitialInventoryCampaign?.custom_url === inventoryCampaign?.custom_url &&
            innitialInventoryCampaign?.ppc_bid_active === inventoryCampaign?.ppc_bid_active &&
            innitialInventoryCampaign?.img_lg === inventoryCampaign?.img_lg &&
            innitialInventoryCampaign?.img_sm === inventoryCampaign?.img_sm &&
            innitialInventoryCampaign?.custom_url === inventoryCampaign?.custom_url &&
            innitialInventoryCampaign?.tagline === inventoryCampaign?.tagline &&
            innitialInventoryCampaign?.custom_description === inventoryCampaign?.custom_description &&
            innitialInventoryCampaign?.content_type === inventoryCampaign?.content_type

        const campaignInactive = !campaign?.ppc_active
        const cpcIsValid = typeof cpc === 'number' && typeof minBid === 'number' && cpc >= minBid

        let baseDisabled = nothingChanged || campaignInactive

        if (isContentAd) {
          baseDisabled = baseDisabled || isContentAdMissingData
        }

        const isDisabled = baseDisabled || !cpcIsValid

        return isDisabled
    }

    return (
        <Modal id="PPCManagmentModal" show={show} onHide={handleClose} size="lg" centered>
            <Modal.Header closeButton className="card-one pb-2">
                <Modal.Title>
                    <div className="d-flex align-items-center">
                        {!inventoryCampaign && (
                            <Placeholder animation="glow">
                                <Placeholder style={{ height: 30, width: '200px' }} />
                            </Placeholder>
                        )}
                        <span>{inventoryCampaign?.inventory?.name}</span>
                        {isClusterInventoryCampaign && (
                            <div className="d-flex align-items-center ms-2">
                                <div className="d-flex align-items-center">
                                    <small className={`cluster-level-indicator ${clusterLevel === 1 ? 'dc' : clusterLevel === 2 ? 'c1' : 'c2'}`}>
                                        {clusterLevel === 1 ? 'DC' : clusterLevel === 2 ? 'C1' : 'C2'}
                                    </small>
                                    {inventoryCampaign?.inventory?.name?.split('@')[6] === 'true' && (
                                        <i className="directory-symbol-legend ms-2">D</i>
                                    )}
                                </div>
                            </div>
                        )}
                    </div>
                    <p
                        className="d-flex gap-2 mb-0"
                        style={{
                            fontSize: '12px',
                            fontWeight: 400,
                            color: '#6e7985'
                        }}
                    >
                        {HTR_PUBLISHER_ID !== publisherIdByAbbr && HTR_STAGE_PUBLISHER_ID !== publisherIdByAbbr && DEFAULT_ID !== publisherIdByAbbr
                            ? inventoryCampaign?.inventory?.related_categories_ids
                                  ?.map(category => {
                                      return campaign?.columns
                                          ?.find(({ name }) => name === 'related_categories_ids')
                                          ?.options?.find(({ value }) => value === category)?.label
                                  })
                                  .filter(category => category)
                                  .join(', ')
                            : ''}
                    </p>
                </Modal.Title>
            </Modal.Header>
            <Modal.Body className="card-one pt-0">
                <Row>
                    <PPCModalPlacements
                        inventoryCampaign={inventoryCampaign}
                        campaignId={campaignId}
                        isHTR={isHTR}
                        isContentAd={isContentAd}
                        language={language}
                        auctionType={auctionType}
                    />
                    <ContentAuctionTabs
                        isHTR={isHTR}
                        isContentAd={isContentAd}
                        auctionType={auctionType}
                        currentTab={currentTab}
                        handleSwitchTab={handleSwitchTab}
                        ppc_modal_labels={ppc_modal_labels}
                        language={language}
                    />
                    {/* manage bid tab */}
                    {currentTab === 'manage_bid' ? (
                        <Col sm="12">
                            <Form>
                                <Row>
                                    <Col sm="6">
                                        <BidModalAmount
                                            inventoryCampaign={inventoryCampaign}
                                            onChangeCpc={onChangeCpc}
                                            defaultValue={defaultValue}
                                            cpcInputValue={cpcInputValue}
                                            disableCPC={disableCPC}
                                            rate={rate}
                                            currentCPC={currentCPC}
                                            onChangeCpcByButton={onChangeCpcByButton}
                                        />
                                        {/* {
                                                        // TODO: Add the translation
                                                        publisher?.min_increment < 1 && (
                                                            <div className="text-center small mb-4">
                                                                <span>Bids can only be increased in increments of </span>
                                                                <OverlayContainer amount={publisher?.min_increment} rate={rate}>
                                                                <span className="fw-bold">${publisher?.min_increment}</span>
                                                                </OverlayContainer>
                                                            </div>
                                                        )
                                                    } */}
                                        <div className="auction-info">
                                            <OverlayTrigger
                                                placement="bottom"
                                                overlay={
                                                    <Tooltip placement="bottom">
                                                        {inventoryCampaign?.ppc_bid_active
                                                            ? taxonomy.tooltips.ppc_managment_modal.ppc_bid_active.active
                                                            : taxonomy.tooltips.ppc_managment_modal.ppc_bid_active.inactive}
                                                    </Tooltip>
                                                }
                                            >
                                                <div className="auction-info-item" id="bid-modal-toggle">
                                                    <BidStatusLabel
                                                        active={inventoryCampaign?.ppc_bid_active}
                                                        labelActive={ppc_modal_labels[language].ppc_bid_active}
                                                        labelInactive={ppc_modal_labels[language].ppc_bid_inactive}
                                                    />
                                                    <span className="switch fw-bold">
                                                        <div className="form-check form-switch">
                                                            <input
                                                                type="checkbox"
                                                                className={
                                                                    inventoryCampaign?.ppc_bid_active
                                                                        ? 'form-check-input bg-primary'
                                                                        : 'form-check-input bg-danger unchecked'
                                                                }
                                                                checked={inventoryCampaign?.ppc_bid_active}
                                                                onChange={e => onChangePPCActive(e)}
                                                            />
                                                        </div>
                                                    </span>
                                                </div>
                                            </OverlayTrigger>
                                            <OverlayTrigger
                                                placement="bottom"
                                                overlay={
                                                    <Tooltip placement="bottom">
                                                        <BidStatusTooltip
                                                            campaign={campaign}
                                                            inventoryCampaign={inventoryCampaign}
                                                            publisher={publisher}
                                                            clusterLevel={clusterLevel}
                                                            language={language}
                                                            renderStatusStr={renderStatusStr}
                                                            render_status_labels={render_status_labels}
                                                            taxonomy={taxonomy}
                                                        />
                                                    </Tooltip>
                                                }
                                            >
                                                <div className="auction-info-item">
                                                    <i className="ri-information-line"></i>
                                                    <span>{ppc_modal_labels[language].bid_status}</span>
                                                    <span className="switch">
                                                        <div style={{ marginRight: '10px' }}>
                                                            {renderStatus(
                                                                campaign?.ppc_active,
                                                                inventoryCampaign?.inventory_campaign_status,
                                                                inventoryCampaign?.ppc_bid_active,
                                                                campaign?.ppc_paused,
                                                                inventoryCampaign?.inherited_cpc,
                                                                publisher?.cluster_inherited_bid_mode_enabled,
                                                                clusterLevel,
                                                                inventoryCampaign?.cluster_status,
                                                                language
                                                            )}
                                                        </div>
                                                    </span>
                                                </div>
                                            </OverlayTrigger>
                                            <div className="auction-info-item">
                                                <i className="ri-auction-line"></i>
                                                <span>
                                                    {estimatedPosition?.current_position != inventoryCampaign?.position
                                                        ? ppc_modal_labels[language].estimated_position
                                                        : ppc_modal_labels[language].current_position}
                                                </span>
                                                <span className="number inline-block">{renderPosition(estimatedPosition, inventoryCampaign)}</span>
                                            </div>
                                            <OverlayTrigger
                                                placement="bottom"
                                                overlay={<Tooltip placement="bottom">{translatedPpcModalTooltips.min_required_bid}</Tooltip>}
                                            >
                                                <div className="auction-info-item">
                                                    <i className="ri-coins-line"></i>
                                                    <span>{ppc_modal_labels[language].minimum_bid}</span>
                                                    <OverlayContainer amount={inventoryCampaign?.min_bid} rate={rate}>
                                                        <span className="number">${inventoryCampaign?.min_bid}</span>
                                                    </OverlayContainer>
                                                </div>
                                            </OverlayTrigger>
                                            <OverlayTrigger
                                                placement="bottom"
                                                overlay={<Tooltip placement="bottom">{translatedPpcModalTooltips.cur_top_bid}</Tooltip>}
                                            >
                                                <div className="auction-info-item">
                                                    <i className="ri-vip-line"></i>
                                                    <span>{ppc_modal_labels[language].current_top_bid}</span>
                                                    <OverlayContainer amount={estimatedPosition?.top_bid} rate={rate}>
                                                        <span className="number">
                                                            $
                                                            {estimatedPosition?.top_bid != '0'
                                                                ? estimatedPosition?.top_bid
                                                                : inventoryCampaign?.stat?.top_cpc_bid == '0'
                                                                ? inventoryCampaign?.min_bid
                                                                : inventoryCampaign?.stat?.top_cpc_bid}
                                                        </span>
                                                    </OverlayContainer>
                                                </div>
                                            </OverlayTrigger>
                                            <OverlayTrigger
                                                placement="bottom"
                                                overlay={<Tooltip placement="bottom">{translatedPpcModalTooltips.amount_of_views}</Tooltip>}
                                            >
                                                <div className="auction-info-item">
                                                    <i className="ri-funds-line"></i>
                                                    <span>{ppc_modal_labels[language].thirty_days_views}</span>
                                                    <span className="number">
                                                        {formatThousand(
                                                            //inventoryCampaign?.stat?.total_views
                                                            views
                                                        )}
                                                    </span>
                                                </div>
                                            </OverlayTrigger>
                                        </div>
                                    </Col>
                                    <Col sm="6" className="d-none d-sm-block">
                                        {auctionType !== 'interval' && (
                                            <div className="auction-preview" style={{ minHeight: '300px' }} id="bid-modal-preview">
                                                <Row>
                                                    <Col xs="12">
                                                        <div id="bid-management">
                                                            <div className="mb-3">
                                                                <div className="section-title">
                                                                    {ppc_modal_labels[language].auction_preview}
                                                                    {inventoryCampaign && !inventoryCampaign?.ppc_bid_active && (
                                                                        <Badge bg="danger" className="ms-2 inline-block">
                                                                            {ppc_modal_labels[language].ppc_inactive}
                                                                        </Badge>
                                                                    )}
                                                                    {!isHTR && (
                                                                        <OverlayTrigger
                                                                            placement="right"
                                                                            overlay={
                                                                                <Tooltip placement="bottom">
                                                                                    Actual positions may differ, due to audience customization and
                                                                                    rotation between equal bids.
                                                                                </Tooltip>
                                                                            }
                                                                        >
                                                                            <i className="ri-information-line text-primary ms-2"></i>
                                                                        </OverlayTrigger>
                                                                    )}
                                                                </div>
                                                            </div>
                                                            {estimatedPosition?.inventory_campaigns?.length > 0 ? (
                                                                <ol className="vendor-list">
                                                                    {estimatedPosition?.inventory_campaigns?.map((item, index) => {
                                                                        return (
                                                                            <li
                                                                                key={index}
                                                                                data-position={item.position}
                                                                                className={
                                                                                    item.campaign_id === inventoryCampaign?.campaign_id
                                                                                        ? 'vendor current'
                                                                                        : 'vendor'
                                                                                }
                                                                            >
                                                                                <div className="d-sm-flex align-items-center">
                                                                                    <div className="avatar avatar-xs" style={{ minWidth: 20 }}>
                                                                                        {item.campaign_id === inventoryCampaign?.campaign_id ? (
                                                                                            campaign?.logo_file ? (
                                                                                                <img
                                                                                                    src={campaign?.logo_file}
                                                                                                    alt="logo"
                                                                                                    className="avatar-img"
                                                                                                />
                                                                                            ) : (
                                                                                                placeholderLogoModule(
                                                                                                    publisherIdByAbbr,
                                                                                                    currentSkin,
                                                                                                    item.logo
                                                                                                )
                                                                                            )
                                                                                        ) : (
                                                                                            <div className="avatar-img" />
                                                                                        )}
                                                                                    </div>
                                                                                    <span className="ms-2 fs-sm">
                                                                                        {item.id === inventoryCampaign?.id ? (
                                                                                            <strong>{item?.inventory_name}</strong>
                                                                                        ) : (
                                                                                            <span>{item?.inventory_name}</span>
                                                                                        )}
                                                                                        {item.id === inventoryCampaign?.id &&
                                                                                        inventoryCampaign?.inventory_campaign_status ===
                                                                                            REVIEW_STATUS ? (
                                                                                            <OverlayTrigger
                                                                                                placement="bottom"
                                                                                                overlay={
                                                                                                    <Tooltip placement="bottom">
                                                                                                        {translatedPpcModalTooltips.under_review}
                                                                                                    </Tooltip>
                                                                                                }
                                                                                            >
                                                                                                <span className="badge bg-outline-warning ms-2">
                                                                                                    {ppc_modal_labels[language]['Under Review']}
                                                                                                </span>
                                                                                            </OverlayTrigger>
                                                                                        ) : (
                                                                                            <></>
                                                                                        )}
                                                                                        {item.id === inventoryCampaign?.id &&
                                                                                        inventoryCampaign?.inventory_campaign_status ===
                                                                                            DRAFT_STATUS ? (
                                                                                            <OverlayTrigger
                                                                                                placement="bottom"
                                                                                                overlay={
                                                                                                    <Tooltip placement="bottom">
                                                                                                        {translatedPpcModalTooltips.draft}
                                                                                                    </Tooltip>
                                                                                                }
                                                                                            >
                                                                                                <span className="badge bg-outline-secondary ms-2">
                                                                                                    {ppc_modal_labels[language].draft}
                                                                                                </span>
                                                                                            </OverlayTrigger>
                                                                                        ) : (
                                                                                            <></>
                                                                                        )}
                                                                                        {item.id === inventoryCampaign?.id &&
                                                                                        inventoryCampaign?.inventory_campaign_status ===
                                                                                            LIVE_STATUS ? (
                                                                                            <OverlayTrigger
                                                                                                placement="bottom"
                                                                                                overlay={
                                                                                                    <Tooltip placement="bottom">
                                                                                                        {translatedPpcModalTooltips.approved}
                                                                                                    </Tooltip>
                                                                                                }
                                                                                            >
                                                                                                <span className="badge bg-outline-success badge-approved ms-2">
                                                                                                    {render_status_labels[language].Approved}
                                                                                                </span>
                                                                                            </OverlayTrigger>
                                                                                        ) : (
                                                                                            <></>
                                                                                        )}
                                                                                        {item.id === inventoryCampaign?.id &&
                                                                                        inventoryCampaign?.inventory_campaign_status ===
                                                                                            REJECTED_STATUS ? (
                                                                                            <span className="badge bg-outline-danger ms-2">
                                                                                                Rejected
                                                                                            </span>
                                                                                        ) : (
                                                                                            <></>
                                                                                        )}
                                                                                    </span>
                                                                                </div>
                                                                            </li>
                                                                        )
                                                                    })}
                                                                </ol>
                                                            ) : (
                                                                <div className="text-center">
                                                                    <ol className="vendor-list">
                                                                        {/* {[...Array(inventoryCampaign?.vendors?.length || (isHTR ? 10 : 6))].map((item, index) => (
                                                                                        <li key={index} className="vendor">
                                                                                            <div className="d-sm-flex align-items-center">
                                                                                                <div className="avatar avatar-xs" style={{ minWidth: "20px" }}>
                                                                                                    <div className="avatar-img">
                                                                                                        <Spinner animation="border" role="status" style={{ width: "20px", height: "20px", color: "rgb(215 219 223)" }}>
                                                                                                            <span className="visually-hidden">Loading...</span>
                                                                                                        </Spinner>
                                                                                                    </div>
                                                                                                </div>
                                                                                                <div className="ms-2 fs-sm">
                                                                                                    <div className="placeholder-glow" style={{ height: 13, width: `${getConsistentWidth(index)}`, backgroundColor: "rgb(215 219 223)" }}></div>
                                                                                                </div>
                                                                                            </div>
                                                                                        </li>
                                                                                    ))} */}
                                                                        <PreviewLoader
                                                                            length={inventoryCampaign?.vendors?.length || (isHTR ? 10 : 6)}
                                                                            getConsistentWidth={getConsistentWidth}
                                                                        />
                                                                    </ol>
                                                                </div>
                                                            )}
                                                        </div>
                                                    </Col>
                                                </Row>
                                            </div>
                                        )}

                                        {auctionType === 'interval' && (
                                            <IntervalAuctionPreview
                                                isHTR={isHTR}
                                                inventoryCampaign={inventoryCampaign}
                                                estimatedPosition={estimatedPosition}
                                                campaign={campaign}
                                                currentSkin={currentSkin}
                                                publisherIdByAbbr={publisherIdByAbbr}
                                                translatedPpcModalTooltips={translatedPpcModalTooltips}
                                                ppc_modal_labels={ppc_modal_labels}
                                                language={language}
                                                getConsistentWidth={getConsistentWidth}
                                                render_status_labels={render_status_labels}
                                                estimateIsLoading={estimateIsLoading}
                                                inventoryId={inventoryId}
                                            />
                                        )}
                                    </Col>
                                </Row>
                                {tooltipContent?.length > 0 && ![10].includes(publisherIdByAbbr) && (
                                    <OverlayContainer amount={tooltipContent}>
                                        <Row className="mt-3 mb-2">
                                            <Col sm="12">
                                                <div className="ppc-danger-system-alert show mb-0">
                                                    <div className="items-center w-100 d-flex align-items-center">
                                                        <div className="icon" style={{ marginRight: 10 }}>
                                                            <i className="ri-information-line" style={{ fontSize: 20 }}></i>
                                                        </div>
                                                        {tooltipContent}
                                                    </div>
                                                </div>
                                            </Col>
                                        </Row>
                                    </OverlayContainer>
                                )}
                                {isHTR && (
                                    <Row className="mt-2">
                                        <Col sm="12">
                                            <div className="divider mt-2">
                                                <span>{ppc_modal_labels[language].landing_page_url}</span>
                                                {/* <span>Landing Page URL(s)</span> */}
                                            </div>
                                        </Col>
                                        <Col sm="12" className="text-center">
                                            <Form className="row align-items-center">
                                                <div className="col-12">
                                                    <div className="input-group">
                                                        <Form.Control
                                                            type="url"
                                                            id="landingPageLink"
                                                            placeholder={campaign?.ppc_default_url}
                                                            value={inventoryCampaign?.custom_url}
                                                            onChange={e => onChangeCustomUrl(e)}
                                                        />
                                                    </div>
                                                </div>
                                            </Form>
                                        </Col>
                                    </Row>
                                )}
                            </Form>
                        </Col>
                    ) : (
                        <CustomizeAdTab
                            landingPageUrl={ppc_modal_labels[language].landing_page_url}
                            inventoryCampaign={inventoryCampaign}
                            onChangeCustomUrl={e => onChangeCustomUrl(e)}
                            setInventoryCampaign={setInventoryCampaign}
                        />
                    )}
                    <Col sm="12" className="text-center">
                        <BidModalButtons
                            campaign={campaign}
                            inventoryCampaign={inventoryCampaign}
                            innitialInventoryCampaign={innitialInventoryCampaign}
                            language={language}
                            ppc_modal_labels={ppc_modal_labels}
                            estimateIsLoading={estimateIsLoading}
                            handleSave={handleSave}
                            handleSubmitBid={handleSubmitBid}
                            handleWithdrawBid={handleWithdrawBid}
                            disabled={isSubmitOnSaveButtonDisabled({
                                innitialInventoryCampaign,
                                inventoryCampaign,
                                campaign,
                                estimateIsLoading
                            })}
                        />
                        <PPCAlerts
                            campaign={campaign}
                            inventoryCampaign={inventoryCampaign}
                            auctionType={auctionType}
                            isContentAd={isContentAd}
                            language={language}
                            DRAFT_STATUS={DRAFT_STATUS}
                            ppc_modal_alert_messages={ppc_modal_alert_messages}
                            is_content_auction={isContentAd}
                            changeTab={handleSwitchTab('upload_content')}
                        />
                    </Col>
                </Row>
            </Modal.Body>
        </Modal>
    )
}
